import RouteNames from '@/constants/RouteNames';
import type { AppRouteRecord } from '@/types/core';

export const authCallbackRoute: AppRouteRecord = {
  component: () => import('@/views/core/AuthCallback.vue'),
  meta: {
    requiresAuth: false,
  },
  name: RouteNames.AuthCallback,
  path: '/auth/callback',
};

export const loginRoute: AppRouteRecord = {
  component: () => import('@/views/core/LoginView.vue'),
  meta: {
    requiresAuth: false,
  },
  name: RouteNames.Login,
  path: '/login',
};

export const homeRoute: AppRouteRecord = {
  path: '/',
  redirect: { name: RouteNames.Movement.List },
};

export const errorNotFoundRoute: AppRouteRecord = {
  component: () => import('@/views/core/NotFound.vue'),
  name: RouteNames.NotFound,
  path: '/:pathMatch(.*)*',
};

export const errorUnauthorizedRoute: AppRouteRecord = {
  component: () => import('@/views/core/Unauthorized.vue'),
  name: RouteNames.Unauthorized,
  path: '/unauthorized',
};
